<template>
<router-view/>
</template>

<script>
export default {
  name: "AgentWrapper"
}
</script>

<style scoped>

</style>